import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    selectStyle: {
      width: theme.spacing(35),
    },
  };
};
